import { LargeVisionActionTypes } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import { PlaylistInteractions } from '../../types'

/**
 * Large Vision Interactions Per Playlist reducer
 */
const largeVisionInteractionsPerPlaylist = buildAsyncStatReducer({
    key: Metrics.LARGEVISION_INTERACTIONS_PLAYLISTS,
    types: {
        request: LargeVisionActionTypes.DASHBOARD_LARGEVISION_INTERACTIONS_PLAYLIST.request,
        success: LargeVisionActionTypes.DASHBOARD_LARGEVISION_INTERACTIONS_PLAYLIST.success,
        failure: LargeVisionActionTypes.DASHBOARD_LARGEVISION_INTERACTIONS_PLAYLIST.failure,
    },
    transform: (state, { payload }): PlaylistInteractions[] => payload,
})

export default largeVisionInteractionsPerPlaylist
